// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5H9.5C8.94772 5 8.5 5.44772 8.5 6V11C8.5 11.5523 8.94772 12 9.5 12H14.5C15.0523 12 15.5 12.4477 15.5 13V18C15.5 18.5523 15.0523 19 14.5 19H8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-s',
    ref,
    icon: element,
  },
));

LettersSIcon.displayName = 'LettersSIcon';

export default LettersSIcon;
